import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const LOGGED_IN = 'LOGGED_IN';

export const useOnCredentialsLogin = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback(() => {
        const event = new CustomEvent(LOGGED_IN);

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('auth:credentials:login', handleEvent);

        return () => publicEventsAPIService.off('auth:credentials:login', handleEvent);
    }, [handleEvent]);
};
